import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {QuestionActionRequest} from 'src/app/model/prototypes';
import {QuestionComponentBase} from 'src/app/model/QuestionComponentBase';
import {environment} from 'src/environments/environment';
import {V3Qa, V3QaAnswerHolder} from '../../../model/v3/cspa';
import {Recorder} from '../../../model/recorder';
import {AudioRecorderService, RecorderState} from '../../../services/api/impl/rest/audio-recorder.service';
import {QuestionService} from '../../../services/api/impl/rest/question.service';
import {ShortcutService} from '../../../services/shortcut.service';
import {LogsService} from "../../../../utils/services/logs.service";
import {Subscription} from "rxjs";
import {AuthorizationServiceProvider} from 'src/app/auth_profile/services/authorization-service.provider';

@Component({
    selector: 'app-qa',
    templateUrl: './qa.component.html',
    styleUrls: ['./qa.component.scss'],
    standalone: false
})
export class QaComponent extends QuestionComponentBase<V3QaAnswerHolder, V3Qa> implements OnInit, OnDestroy {

  isQuestionHidden = true
  isAnswerHidden = true
  isAnswerBlockHidden = true
  isQuestionPulsing = true
  isAnswerPulsing = true
  canPlayAnswer = false
  isPlaying = false
  showPlay = false;
  recorder: Recorder;
  recording = false;
  readyToPlayNative = false;
  @ViewChild('audioTarget', {static: false}) audioTarget: ElementRef;
  qaRequestStart: QuestionActionRequest[] = [
    {
      text: 'microphone',
      assetUrl: 'mic'
    },
    {
      text: 'play',
      assetUrl: 'play-arrow-filled'
    }
  ]
  qaRequestStop: QuestionActionRequest[] = [
    {
      text: 'stop',
      assetUrl: 'stop-circle-blue'
    },
    {
      text: 'play',
      assetUrl: 'play-arrow-filled'
    }
  ]

  constructor(
    private audioRecorder: AudioRecorderService,
    private shortcut: ShortcutService,
    private questionService: QuestionService,
    logs: LogsService,
    authProvider: AuthorizationServiceProvider) {
      super(logs, authProvider);
  }

  sendRequest(qaRequest: QuestionActionRequest[]) {
    this.updateActionMenu.emit(qaRequest)
  }

  public setUpAnswer(answer: V3QaAnswerHolder) {
    this.answer = answer ?? {}
  }

  private shortcutButtonSubscription: Subscription;
  private recorderStateSubscription: Subscription;
  override ngOnDestroy() {
    super.ngOnDestroy();
    if (this.shortcutButtonSubscription) this.shortcutButtonSubscription.unsubscribe()
    if (this.recorderStateSubscription) this.recorderStateSubscription.unsubscribe()

  }

  ngOnInit(): void {
    this.sendRequest(this.qaRequestStart)
    this.audioRecorder.init().subscribe( recorder => {
      this.recorder = recorder;
      this.recorderStateSubscription = recorder.getRecorderState().subscribe(state =>
        this.recording = state === RecorderState.Recording);
      this.shortcutButtonSubscription = this.shortcut.btnRequest.subscribe(btn => {
        btn === 'microphone' && this.recordClicked()
        btn === 'stop' && this.stopRecording()
        btn === 'play' && this.play()
        })
    })

    this.questionSubscription = this.questionService.answerRequest.subscribe(sendAnswer => {
      sendAnswer &&
      sendAnswer['answerType'] === 'V3Qa' &&
      sendAnswer['getNewAnswer'] === true &&
      this.getAnswerForSubmit()
    })
  }

  getAnswerForSubmit() {
    this.sendAnswer()
  }

  getQuestion() {
    if(this.isQuestionHidden) return "..."
    else return (this.question?.questionDef as V3Qa)?.question
  }

  getPrompt() {
    const questionDef = this.question.questionDef as V3Qa
    let prompt = ''
    questionDef.prompt.forEach(item => prompt += item)
    return prompt
  }

  getAnswer() {
    if(this.isAnswerHidden) return this.getPrompt()
    else return (this.question?.questionDef as V3Qa)?.questionAnswer
  }

  isCFK() {
    return this.question.questionDef.path.startsWith("encfk")
  }

  getCFKImageSrc() {
    return `${environment.awsBase}${(this.question.questionDef as V3Qa).img}`
  }

  toggleQuestion() {
    this.isQuestionHidden = !this.isQuestionHidden
  }

  toggleAnswer() {
    this.isAnswerHidden = !this.isAnswerHidden
  }

  playUrl(url: string, onFinish: () => void) {
    if (this.isPlaying) return;
    this.isPlaying = true;
    const audio = new Audio();
    audio.src = url;
    audio.onended = () => {
      this.isPlaying = false;
      onFinish();
    };
    audio.load();
    audio.play().then(
      null,
      () => this.isPlaying = false
    );
  }

  playQuestion() {
    if (!this.question) {
      return;
    }
    this.isQuestionPulsing = false
    const questionDef = this.question.questionDef as V3Qa
    this.playUrl(
      environment.awsBase + questionDef.src + 'question.mp3',
      () => this.isAnswerBlockHidden = false
      );
    this.canPlayAnswer = true
  }

  playAnswer() {
    this.isAnswerPulsing = false
    const questionDef = this.question.questionDef as V3Qa
    this.playUrl(environment.awsBase + questionDef.src + 'answer.mp3',
    () => {
      if (!this.answer) this.answer = {}
      this.inProgressEmitter.emit(false)
    })
  }

  stopRecording() {
    this.recorder.stop().subscribe( blob => {
      this.sendRequest(this.qaRequestStart)
      if (blob == null) {
        this.readyToPlayNative = true;
      } else {
        this.audioTarget.nativeElement.src = URL.createObjectURL(blob);
      }
      this.showPlay = true;
    })
  }

  recordClicked() {
    this.recorder.stop()
    .subscribe(_ => {
      this.sendRequest(this.qaRequestStop)
      this.recorder.clear()
        this.showPlay = false;
        this.recorder.record();
      }
    );
  }

  play() {
    this.stopRecording()
    this.recorder.stop().subscribe( blob => {
      if (blob == null) {
        this.recorder.play();
      } else {
        this.audioTarget.nativeElement.load();
        this.audioTarget.nativeElement.play();
      }
    });
  }
}
